<template>
  <th class="table-header-cell" v-if="show" :class="{ oldEmpty: isEmptyFilter}">
    <span v-tooltip="{content: tooltip}" :class="{highlight: filterValue !== undefined && filterValue !== ''}">
         <slot :filter="filter" :table="vuetable"/>
    </span>
  </th>
</template>
<script>
export default {
  name: "DoctuTableHeaderCellSimple",
  props: {
    tooltip: {
        default: '',
    },
    inputStyle: '',
    name: {},
    title: {},
  },
  data() {
    let val = this.filterValue;
    return {
      mouseOver: false,
      filter: {
        value: val
      },
    }
  },
  created() {
    this.filter.value = this.filterValue;
  },
  mounted() {
    let title = this.title || '';
    if (!title) {
      let slot = this.$slots.default;
      if (slot) {
        title = slot[0].text;
        if (!title) {
          if (slot[0].elm.tagName === 'I') {
            title = slot[0].elm.outerHTML;
          }
        }
      }
    }

    if (title) {
      this.$parent.$parent.pushField({
          name: this.name,
          title: title,
          tooltip: this.tooltip
      })
    }
  },
  watch: {
    'filter.value': function (value) {
      let payload = {};
      payload[this.name] = value;
      this.$parent.$parent.filterUpdate(payload);
    },
    filterValue: function (value) {
      this.filter.value = value || '';
    }
  },
  computed: {
      isEmptyFilter () {
          return this.filter.value === '' || typeof this.filter.value === 'undefined';
      },
    show: function () {
      return (this.hidden.indexOf(this.name) < 0);
    },

    hidden: function () {
      return this.$parent.hidden
    },


    filters: function () {
      return this.$parent.filter
    },

    vuetable: function () {
      return this.$parent.$parent;
    },

    filterValue: function () {
      return this.filters[this.name];
    },
  },

}
</script>
<style>
.table-header-cell {
    position: relative;
}
.table-header-cell .highlight input, .table-header-cell .highlight select {
    background-color: #fffd03 !important;
}
.order {
    position: absolute;
    right: 0px;
}
.grey {
    color: #808080bd;
}
</style>
